import gql from 'graphql-tag';
import PaymentMethodAllFragment from '../fragments/PaymentMethodAllFragment';

export default gql`
query PaymentMethod($id: Int!) {
    adminPaymentMethodById(id:$id) {
        ...PaymentMethodAllFragment
    }
}
${PaymentMethodAllFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminPaymentMethod.ts